document.addEventListener('turbolinks:load', () => {
    // Scroll anchor Element to Bottom of page
    // This is to prevent a bug in Chrome where half of the page got unusable
    // Only used in the forms of mmg_app and byod_app
    if (document.getElementById('byodAppForm') || document.getElementById('mmgAppForm')){
        if (location.hash) {
            const anchorElement = document.querySelector(location.hash);
            if (anchorElement) {
                // Standard-Sprung rückgängig machen, dann neu scrollen
                setTimeout(() => {
                    anchorElement.scrollIntoView({block: "end", inline: "nearest"});
                }, 0);
            }
        }
    }
})